import { gql } from '@apollo/client';

export const GET_SPONSORED_USERS = gql`
  query GetSponsoredUsers {
    getSponsoredUsers {
      id
      username
      email
      cnumber
      realname
      sponsor
      sponsor_name
      disabled
      last_confirmation
      days_since_confirmation
    }
  }
`;

export const CONFIRM_USERS = gql`
  mutation ConfirmUsers($userIds: [Int!]!) {
    confirmUsers(userIds: $userIds) {
      success
      confirmedCount
      errors
    }
  }
`;

export const DISABLE_USER = gql`
  mutation DisableUser($username: String!) {
    disableUser(username: $username) {
      success
      message
    }
  }
`;

export const UPDATE_USER_SPONSOR = gql`
  mutation UpdateUserSponsor($userId: Int!, $newSponsor: String!) {
    updateUserSponsor(userId: $userId, newSponsor: $newSponsor) {
      success
      message
    }
  }
`;
